import { ValueSource } from "constants/ruleBooks";
import {
  getPropertyDisplayName,
  LinkedRootDataType,
} from "containers/Settings/RuleBooks/Schema/schema";
import { RuleChain } from "containers/Settings/RuleBooks/Schema/livestockSaleSchema";
import { getParentInputDataType } from "containers/Settings/RuleBooks/import";

interface DataSource {
  source: ValueInObj<typeof ValueSource>;
  value?: string | number;
  criteria_output_index?: number;
}

export function toFriendlyName(dataSource: DataSource): string {
  if (!dataSource) {
    return "";
  }
  if (dataSource.source === ValueSource.CONSTANT) {
    return `${dataSource.value}`;
  }
  if (
    [
      ValueSource.FIELD,
      ValueSource.DEPENDENCY_VALUE,
      ValueSource.RULESET_FIELD,
    ].includes(dataSource.source)
  ) {
    return getPropertyDisplayName(dataSource.value);
  }
  if (dataSource.source === ValueSource.COUNT) {
    // Should label the datatype instead of using the word items
    return `Number of items in criteria ${+dataSource.criteria_output_index + 1}`;
  }
  if (dataSource.source === ValueSource.SUM) {
    // Should label the datatype instead of using the relation name
    return `Sum of ${getPropertyDisplayName(dataSource.value)}`;
  }
  return `${dataSource}`;
}

export function resolveParentDataType<
  RuleSetVariant extends RuleSet | MasterRuleSet,
>(
  prerequisiteRuleIds: string[],
  ruleChainLookup: Record<string, RuleChain>,
  ruleSetId: string | null,
  ruleSetVariantByIdLookup: Record<string, RuleSetVariant>,
  schema: LinkedRootDataType,
) {
  // Resolve the new parent data type, using the prerequisite rule id's input data type if set,
  // otherwise use the [master] rule set's input data type, if set
  // otherwise there is no parent data type, it uses the base schema
  if (Array.isArray(prerequisiteRuleIds) && prerequisiteRuleIds.length > 0) {
    const firstPrerequisiteRuleId = prerequisiteRuleIds[0];
    const ruleChain: RuleChain = ruleChainLookup[firstPrerequisiteRuleId];
    return getParentInputDataType(ruleChain?.inputPathParts || [], schema);
  }
  if (ruleSetId) {
    const masterRuleSet: RuleSetVariant = ruleSetVariantByIdLookup[ruleSetId];
    return getParentInputDataType([masterRuleSet.input_field] || [], schema);
  }

  return null;
}
